var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefaultTravelerIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 24,
    viewBox: "0 0 34 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0034 19.4224C14.7827 22.3606 17.8003 23.6312 17.8003 23.6312C17.8003 23.6312 20.818 22.3606 23.5973 19.4224C21.6915 19.5812 19.7062 19.6606 17.5621 19.6606C16.6886 19.5812 14.5445 19.5812 12.0034 19.4224Z",
    fill: "#0A68FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8852 16.5691C24.947 17.0456 21.3736 17.3633 17.6413 17.3633C8.19142 17.3633 2.315 15.6956 1.67972 14.5044L0.488556 15.0602C1.75913 17.522 10.2561 18.6337 17.6413 18.6337C21.5324 18.6337 25.1853 18.3161 28.2029 17.8396L28.3617 18.6337L33.6822 16.0926L27.7264 15.8543L27.8852 16.5691Z",
    fill: "#0A68FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9648 11.0078C28.1236 10.1343 28.203 9.18139 28.203 8.22847C28.203 2.66972 26.6942 0.366699 26.6942 0.366699C26.6942 0.366699 22.4854 2.82858 17.8002 0.922729C13.115 2.82858 8.90625 0.366699 8.90625 0.366699C8.90625 0.366699 7.39743 2.66972 7.39743 8.22847C7.39743 9.10198 7.47685 9.89597 7.55626 10.6901C6.84156 10.7695 6.12684 10.9284 5.49155 11.0078L5.25333 10.2137L0.171082 12.7548L6.12688 12.9136L5.88861 12.1195C6.52389 11.9607 7.15918 11.8814 7.87387 11.8019C8.19151 13.2313 8.74741 14.5813 9.38269 15.7725C11.6062 16.0901 14.3856 16.2488 17.6414 16.2488C20.8973 16.2488 23.756 16.09 26.2971 15.693C26.853 14.6606 27.3295 13.4695 27.6471 12.1195C30.9824 12.7548 32.65 13.6283 32.65 14.2636C32.65 14.343 32.65 14.4225 32.5706 14.4225L33.7618 15.1371C33.9206 14.8989 34 14.5813 34 14.343C34 12.7548 31.3795 11.6431 27.9648 11.0078Z",
    fill: "#0A68FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultTravelerIcon);
export default ForwardRef;